// // //Search Bar Focus - Fade out nav
// $('#site-navigation form[role=search]').on('focusin', function(){
//     var navItems = $('.header__bottom-navigation .nav-item').get().reverse();
//     $(navItems).each(function(index) {
//       $(this).delay(100*index).queue(function(){
//         $(this).addClass('make-room').dequeue();
//       });
//     });
//   });
//   $('#site-navigation form[role=search]').on('focusout', function(){
//     $('.header__bottom-navigation .nav-item').each(function(index) {
//       $(this).delay(100*index).queue(function(){
//         $(this).removeClass('make-room').dequeue();
//       });
//     });
//   });


// //Cheap loading screen
// //
// setTimeout(function(){
//   $('body').css('opacity','1');
//   console.log('showbody');
// },500);

// //Mobile nav click event
// //
// $('.header__burger-navigation').on('click',function(){
//     $(this).toggleClass('make-criss-cross-applesauce');
//     const masthead = $('#masthead');
//     const mobile_menu = $('#mobile-menu');
//     mobile_menu.toggleClass('mobile-nav__takeover--active')
//       // 'isAdding' will be true when the class is being added and false when removed
//     if (mobile_menu.hasClass('mobile-nav__takeover--active')) {
//       console.log(masthead.outerHeight(true));
//       mobile_menu.css("top", masthead.outerHeight(true));
//     } else {
//       mobile_menu.css("top", '');
//     }
//     //$('#site-navigation .header__logo-wrapper').toggleClass('hide');
//     //$('#masthead').toggleClass('mobile-nav');
//     //$('#page').toggleClass('mobile-move');
//     //prevents scrolling
//    //$('body').toggleClass('prevent-scrolling');
// });

// //Dropdown for subnav items (desktop)
// //
// $('.header__bottom-navigation .nav-item').hover(function(){
//        // mouse in
//        //remove old any active
//        $('.header__bottom-navigation .nav-item__sub-nav--active').each(function (element) {
//             element.removeClass('nav-item__sub-nav--active');
//        });
//         $(this).find('.nav-item__sub-nav').addClass('nav-item__sub-nav--active');
//     },function(){
//         console.log($('div:hover')[0]);
//         if ($('.header__bottom-navigation .nav-item__sub-nav--active:hover').length != 0) {
//             //do nothing
//         } else {
//             $(this).find('.nav-item__sub-nav').removeClass('nav-item__sub-nav--active');
//         }
//     });

// //Dropdown for subnav items (mobile)
// $('.nav-item--has_sub').on('click', 'i', function(e){
//     $(this).next().toggleClass('nav-item__sub-nav--active');
// })


// Search Bar Focus - Fade out nav
// var searchBar = document.querySelector('#site-navigation form[role=search]');

// searchBar.addEventListener('focusin', function() {
//   var navItems = Array.from(document.querySelectorAll('.header__bottom-navigation .nav-item')).reverse();
//   navItems.forEach(function(navItem, index) {
//     setTimeout(function() {
//       navItem.classList.add('make-room');
//     }, 100 * index);
//   });
// });

// searchBar.addEventListener('focusout', function() {
//   var navItems = document.querySelectorAll('.header__bottom-navigation .nav-item');
//   navItems.forEach(function(navItem, index) {
//     setTimeout(function() {
//       navItem.classList.remove('make-room');
//     }, 100 * index);
//   });
// });

// Cheap loading screen
setTimeout(function() {
  document.body.style.opacity = '1';
  console.log('showbody');
}, 1000);

// Mobile nav click event
var burgerNavigation = document.querySelector('.header__burger-navigation');
var masthead = document.getElementById('masthead');
var mobileMenu = document.getElementById('mobile-menu');

const setMainMarginTopToHeaderHeight = () => {
  const main = document.querySelector('main');
  const firstChild = main?.firstElementChild;
  if (masthead && firstChild) {
    firstChild.style.marginTop = `${masthead.offsetHeight}px`;
  }
};

window.addEventListener('load', setMainMarginTopToHeaderHeight);

window.addEventListener('resize', setMainMarginTopToHeaderHeight);


burgerNavigation.addEventListener('click', function() {
  this.classList.toggle('make-criss-cross-applesauce');
  
  mobileMenu.classList.toggle('mobile-nav__takeover--active');

  if (mobileMenu.classList.contains('mobile-nav__takeover--active')) {
    mobileMenu.style.top = masthead.offsetHeight + 'px';
  } else {
    mobileMenu.style.top = '';
  }
});

// Dropdown for subnav items (desktop)
var navItems = document.querySelectorAll('.header__bottom-navigation .nav-item');

navItems.forEach(function(navItem) {
  navItem.addEventListener('mouseenter', function() {
    var activeSubNav = document.querySelector('.header__bottom-navigation .nav-item__sub-nav--active');
    if (activeSubNav) {
      activeSubNav.classList.remove('nav-item__sub-nav--active');
    }
    this.querySelector('.nav-item__sub-nav').classList.add('nav-item__sub-nav--active');
  });

  navItem.addEventListener('mouseleave', function(event) {
    if (!event.relatedTarget.classList.contains('nav-item__sub-nav--active')) {
      this.querySelector('.nav-item__sub-nav').classList.remove('nav-item__sub-nav--active');
    }
  });
});

// Dropdown for subnav items (mobile)
var navItemHasSub = document.querySelectorAll('.nav-item--has_sub');

navItemHasSub.forEach(function(navItem) {
  navItem.addEventListener('click', function() {
    this.querySelector('i').nextElementSibling.classList.toggle('nav-item__sub-nav--active');
  });
});

//Position entry-content so nav can float above

